import { render, staticRenderFns } from "./TemplateForm.vue?vue&type=template&id=504df7f2&scoped=true&"
import script from "./TemplateForm.vue?vue&type=script&lang=js&"
export * from "./TemplateForm.vue?vue&type=script&lang=js&"
import style0 from "./TemplateForm.vue?vue&type=style&index=0&id=504df7f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504df7f2",
  null
  
)

export default component.exports